<script setup lang="ts">
import { reloadForUpdate, updateAvailable } from "../composables/useAppUpdate.js";
import { useI18n } from "../composables/useI18n.js";

/**
 * Shown only when a navigation has already failed on a stale chunk while the
 * player had a match in memory. Everywhere else the reload happens by itself,
 * so this banner is deliberately rare: seeing it means the player is being
 * asked before something they might not want to lose is thrown away.
 */
const { t } = useI18n();
</script>

<template>
  <div v-if="updateAvailable" class="update-banner" role="status">
    <span>{{ t('A new version of Rasenschach was released.') }}</span>
    <button type="button" @click="reloadForUpdate">{{ t('Reload') }}</button>
  </div>
</template>

<style scoped>
.update-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 8px 14px;
  background: rgba(250, 204, 21, 0.1);
  border-bottom: 1px solid rgba(250, 204, 21, 0.3);
  color: var(--gold-text);
  font-size: 0.9rem;
}
.update-banner button {
  border: 1px solid rgba(250, 204, 21, 0.45);
  border-radius: 8px;
  background: rgba(250, 204, 21, 0.14);
  color: var(--gold-text);
  font: inherit;
  font-weight: 700;
  padding: 4px 12px;
  cursor: pointer;
}
.update-banner button:hover { background: rgba(250, 204, 21, 0.24); }
</style>
